import { Component, OnInit } from '@angular/core';
import { SummaryComponent } from '../summary.component';
import { Customer } from '../../../shared/models/customer.interface';

@Component({
  selector: 'app-summary-mobile',
  templateUrl: './summary.mobile.component.html',
  styleUrls: ['./summary.mobile.component.scss']
})
export class SummaryMobileComponent extends SummaryComponent implements OnInit {
 
  ngOnInit() {
    super.init();
  }

}



